import { createRouter, createWebHistory } from "vue-router";

// 创建路由规则
const routes = [
  {
    path: "/",
    name: "Main",
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/elevator",
    name: "elevator",
    component: () => import("@/views/elevator/index.vue"),
  },
  {
    path: "/special",
    name: "special",
    component: () => import("@/views/TZSB/index.vue"),
  },
  {
    path: "/food",
    name: "food",
    component: () => import("@/views/JTYC/index.vue"),
  },
  {
    path: "/medical",
    name: "medical",
    component: () => import("@/views/medical/index.vue"),
  },
  {
    path: "/TSJB",
    name: "TSJB",
    component: () => import("@/views/TSJB/index.vue"),
  },
  {
    path: "/JGZF",
    name: "JGZF",
    component: () => import("@/views/JGZF/index.vue"),
  },
  {
    path: "/ZSCQ",
    name: "ZSCQ",
    component: () => import("@/views/ZSCQ/index.vue"),
  },
  {
    path: "/XYJG",
    name: "XYJG",
    component: () => import("@/views/XYJG/index.vue"),
  },
];
// 创建router实例
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
